import { render } from "./Viewer3D.vue?vue&type=template&id=1df827fc&scoped=true"
import script from "./Viewer3D.vue?vue&type=script&lang=js"
export * from "./Viewer3D.vue?vue&type=script&lang=js"

import "./Viewer3D.vue?vue&type=style&index=0&id=1df827fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df827fc"]])

export default __exports__